<template>
  <div class="row">
    <div class="col-xs-12 col-sm-3">
      <SearchFilters
        :country-options="countryOptions"
        :state-options="stateOptions"
        :industry-options="industryOptions"
        v-model:country-filter="countryFilter"
        v-model:state-filter="stateFilter"
        v-model:industry-filter="industryFilter"
      />
    </div>
    <div class="col-xs-12 col-sm-9">
      <SearchResults
        :distributors="distributors"
        :search-happened="searchHappened"
      />
    </div>
  </div>
</template>

<script>
/* global distributors, countries, states, industries */

import SearchFilters from './components/DistributorSearchFilters.vue'
import SearchResults from './components/DistributorSearchResults'

export default {
  name: 'DistributorSearch',
  components: {
    SearchFilters,
    SearchResults
  },
  data () {
    return {
      allDistributors: distributors,
      allCountries: countries,
      allStates: states,
      allIndustries: industries,
      distributors: [],
      countryFilter: 'US',
      stateFilter: '',
      industryFilter: '',
      searchHappened: false
    }
  },
  computed: {
    countryOptions () {
      const options = []
      for (let i = 0; i < this.allCountries.length; i++) {
        const checkCountry = this.allCountries[i]
        for (let i = 0; i < this.allDistributors.length; i++) {
          if (this.allDistributors[i].countries.includes(checkCountry.abbr)) {
            options.push(checkCountry)
            break
          }
        }
      }
      return options
    },
    stateOptions () {
      const options = []
      for (let i = 0; i < this.allStates.length; i++) {
        const checkState = this.allStates[i]
        for (let i = 0; i < this.allDistributors.length; i++) {
          if (this.allDistributors[i].states.includes(checkState.abbr)) {
            options.push(checkState)
            break
          }
        }
      }
      return options
    },
    industryOptions () {
      const options = []
      for (let i = 0; i < this.allIndustries.length; i++) {
        const checkIndustry = this.allIndustries[i]
        for (let i = 0; i < this.allDistributors.length; i++) {
          if (this.allDistributors[i].industries.includes(checkIndustry.id.toString())) {
            options.push(checkIndustry)
            break
          }
        }
      }
      return options
    }
  },
  watch: {
    countryFilter: function () {
      this.filterDistributors()
    },
    stateFilter: function () {
      this.filterDistributors()
    },
    industryFilter: function () {
      this.filterDistributors()
    }
  },
  methods: {
    filterDistributors: function () {
      this.distributors = []
      this.searchHappened = false

      for (let i = 0; i < this.allDistributors.length; i++) {
        let hide = true
        const checkDistributor = this.allDistributors[i]

        if (this.industryFilter !== '') { // only search if all of the dropdowns have been selected
          if (this.countryFilter !== '' && this.countryFilter !== 'US') { // if we have a country filter do the search
            if (checkDistributor.countries.includes(this.countryFilter)) {
              hide = false
            }
            this.searchHappened = true
          } else if (this.countryFilter === 'US' && this.stateFilter !== '') { // if we have a country filter and a state filter (for US only) do the search
            if (checkDistributor.states.includes(this.stateFilter)) {
              hide = false
            }
            this.searchHappened = true
          }
        }

        if (!hide && this.searchHappened) { // if we searched up above and this distributor is not yet hidden, check the industries
          if (this.industryFilter !== '') {
            hide = (!checkDistributor.industries.includes(this.industryFilter.toString()))
          }
        }

        if (!hide) {
          this.distributors.push(checkDistributor)
        }
      }
    }
  }
}
</script>
